export default __webpack_public_path__ + "static/media/by.13ade374.svg";